import React from 'react';
import { Dialog, Link, List, ListItem, useMediaQuery, useTheme } from '@mui/material';

import { SplitHit } from '../../types/split';
import { modalTypes } from '../../types/modalTypes';

import styles from './statistics.components.module.scss';
function SplitHitModal({ runs, displayText, onClose, type }: { runs: SplitHit[], displayText: string, onClose: any, type: modalTypes }) {
  const isMobile = useMediaQuery(useTheme().breakpoints.down('md'));
  const extraText = 'Hits';
  return (
    <Dialog open onClose={() => onClose([])} className={styles.hitClipsContainer} maxWidth={isMobile ? 'xs' : 'lg'} fullScreen={isMobile ? true : false}>
      <div className={styles.content}>
        <h3>{displayText} {extraText}:</h3>
        <List>
          {(runs.map(gameRun =>
          {
            return (
              <ListItem key={JSON.stringify(gameRun)} className={styles.itemList}>
                <span className={styles.modalItemText}>{gameRun.date}:</span> <Link className={styles.modalLink} href={gameRun.clip}>Hit clip</Link>
              </ListItem>
            );
          }
          ))}
        </List>
      </div>
    </Dialog>
  );
}

export default SplitHitModal;